export default {
  namespaced: true,
  state: () => ({
    // -1: 造新字；其它值：編輯該 glyph id
    id: -1,
  }),
  getters: {
    isCreate(state) {
      return state.id === -1;
    },
    isEdit(state) {
      return state.id !== -1;
    },
  },
  mutations: {
    SET_ID(state, id) {
      state.id = id;
    },
    RESET_ID(state) {
      state.id = -1;
    },
  },
  actions: {
    setGlyphId({ commit }, id) {
      commit('SET_ID', id);
    },
    resetGlyphId({ commit }) {
      commit('RESET_ID');
    },
  },
};
